<template>
    <div style="height:100%" class="menue">
        <template v-for="item in getMenu">
            <el-menu-item :index="item.menuUrl?item.menuUrl:item.id+''" :key="item.id +'num'" v-if="!item.children">
                <i :class="[{icon:true,iconfont:true},item.menuIcon]" style=" font-size:16px;"></i>&nbsp;
                <span slot="title">{{item.menuName}}</span>
            </el-menu-item>
            <el-submenu :index="item.menuUrl?item.menuUrl:item.id+''"  v-else :key="item.id+'menu'">
                <template slot="title">
                    <i :class="[{icon:true,iconfont:true},item.menuIcon]" style="font-size:16px;"></i>&nbsp;
                    <span :class="{'hidden-close':isCollapse}">{{item.menuName}}</span>
                </template>
                <common-menu :getMenu="item.children"></common-menu>
            </el-submenu>
        </template>
    </div>
</template>
<script>
export default {
    name:'CommonMenu',
    props:{
        getMenu:Array,
        isCollapse:Boolean
    },
    data(){
        return{
        }
    },
}
</script>
<style >
.menue .el-menu-item,.menue .el-submenu__title{
    height: 38px !important;
    line-height: 38px !important;
}
.menue .el-menu--inline .el-menu-item{
    height: 28px !important;
    line-height: 28px !important;
    padding-left: 42px !important;
    font-size: 13px;
}
.el-menu-item.is-active{
    font-weight: 600;
    background: #ffffff00 !important;
}
.el-menu-item:hover:not(.is-active), .el-submenu__title:hover{
    background: rgba(72,72,72,0)  !important;
}
.hidden-close{
    display: none;
}
.menue .el-icon-arrow-right{
    display: none;
}
.menue .el-menu{
    border-right: none !important;
}
</style>



// WEBPACK FOOTER //
// src/views/components/menu.vue